export default function(key) {
  if (!document.cookie || document.cookie === '') return null;
  let matches = document.cookie.match(new RegExp(
    '(?:^|; )' + key.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
}
